import AppModalContainer from '@nxsys/components/AppModalContainer';
import AEPNListing from '../../aepn/listing';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  cbAfterAction: () => void;
};

const AEPNUpdateModal: React.FC<Props> = ({ isOpen, toggle, cbAfterAction }) => {
  return (
    <AppModalContainer
      title="AEPN Update"
      isOpen={isOpen}
      toggle={toggle}
      className="max-sm:w-[100vw"
      width={1250}
      minHeight="0"
      noPaddingBody
      hiddenFooter
    >
      <AEPNListing cbAfterAction={cbAfterAction} isDashboard />
    </AppModalContainer>
  );
};

export default AEPNUpdateModal;
